// removed by extract-text-webpack-plugin
module.exports = {"campaignEnterMobileInputContainer":"campaignEnterMobileInputContainer__32bi9","campaignEnterInputBoxMobile":"campaignEnterInputBoxMobile__1LeHD","campaignEnterMobileSubmitButton":"campaignEnterMobileSubmitButton__3CO2p","mobileNoPrefix":"mobileNoPrefix__D1EXK"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVB/enterMobileSection/campaignEnterMobileInput/style.css
// module id = xBWT
// module chunks = 459